import { VURL } from "js-vextensions";
import { BaseComponent, ShallowChanged, FilterOutUnrecognizedProps, cssHelper } from "react-vextensions";
import { Remarkable } from "remarkable";
import RemarkableReactRenderer from "remarkable-react";
import React from "react";
import { ParseTextForPatternMatchSegments } from "../General/RegexHelpers.js";
import { GetCurrentURL } from "../URL/URLs.js";
import { Link } from "./Link.js";
export class VReactMarkdown_Remarkable extends BaseComponent {
    InitMarkdown(props) {
        let { extraInfo, markdownOptions, rendererOptions } = props;
        markdownOptions = markdownOptions || {};
        this.markdown = new Remarkable(markdownOptions);
        const rendererOptions_final = {
            ...rendererOptions,
            components: {
                // modify links to open in new tab, if they're to external sites
                a: (props => {
                    let { href, target, ...rest } = props;
                    const toURL = VURL.Parse(href);
                    if (target == "")
                        target = null; // normalize falsy target
                    if (target == null && toURL.domain != GetCurrentURL().domain) {
                        target = "_blank";
                    }
                    return React.createElement(Link, { ...FilterOutUnrecognizedProps(rest, "a"), to: href, target: target });
                }),
                // disallow images by default (too easy of a means to vandalize; also, could be used to track user IPs)
                // (if caller wants to enable images, they can do so by setting rendererOptions.components.img to undefined, enabling default renderer)
                img: (props => {
                    const { src, alt, title, ...rest } = props;
                    //return <img src={src} alt={alt} title={title} {...rest}/>;
                    return null;
                }),
                /*htmlblock: (props=>{
                    let {content} = props;
                    return <div dangerouslySetInnerHTML={{__html: content}}/>;
                },
                htmltag: (props=>{
                    let {content} = props;
                    return <span dangerouslySetInnerHTML={{__html: content}}/>;
                }),*/
                ...rendererOptions === null || rendererOptions === void 0 ? void 0 : rendererOptions.components,
                /*tokens: {
                    htmlblock: "htmlblock",
                    htmltag: "htmltag",
                    ...rendererOptions?.components?.tokens,
                },*/
            },
        };
        // allow caller to reset a component's renderer to its default values, by setting it to undefined
        for (const [key, value] of Object.entries(rendererOptions_final.components).filter(a => a[1] === undefined)) {
            delete rendererOptions_final.components[key];
        }
        this.markdown.renderer = new RemarkableReactRenderer(rendererOptions_final);
    }
    ComponentWillReceiveProps(props) {
        if (ShallowChanged(props.markdownOptions, this.props.markdownOptions) || ShallowChanged(props.rendererOptions, this.props.rendererOptions)) {
            this.InitMarkdown(props);
        }
    }
    render() {
        const { source, extraInfo, markdownOptions, rendererOptions, replacements, containerType, style, addMarginsForDanglingNewLines, ...rest } = this.props;
        //source = source || this.FlattenedChildren.join("\n\n");
        const { css } = cssHelper(this);
        if (this.markdown == null) {
            this.InitMarkdown(this.props);
        }
        if (replacements) {
            const patterns = replacements.VKeys().map((regexStr, index) => ({ name: `${index}`, regex: new RegExp(regexStr) }));
            const segments = ParseTextForPatternMatchSegments(source, patterns);
            if (segments.length > 1) {
                const segmentUIs = segments.map((segment, index) => {
                    if (segment.patternMatches.size == 0) {
                        if (replacements.default) {
                            return replacements.default(segment, index, extraInfo).VAct(a => a.key = index.toString());
                        }
                        const text = segment.text.replace(/\r/g, "");
                        return (React.createElement(VReactMarkdown_Remarkable, { key: index, source: text.trim(), replacements: replacements, extraInfo: extraInfo, markdownOptions: markdownOptions, rendererOptions: rendererOptions, style: css(addMarginsForDanglingNewLines && {
                                marginTop: text.startsWith("\n\n") ? 15 : text.startsWith("\n") ? 5 : 0,
                                marginBottom: text.endsWith("\n\n") ? 15 : text.endsWith("\n") ? 5 : 0,
                            }), addMarginsForDanglingNewLines: addMarginsForDanglingNewLines }));
                    }
                    const mainPatternMatched = [...segment.patternMatches.keys()][0];
                    const renderFuncForReplacement = replacements.VValues()[mainPatternMatched.name];
                    return renderFuncForReplacement(segment, index, extraInfo).VAct(a => a.key = index.toString());
                });
                return React.createElement(containerType, { style }, segmentUIs);
            }
        }
        const markdownResult = this.markdown.render(source);
        return React.createElement(containerType, { ...rest, style }, markdownResult);
    }
}
VReactMarkdown_Remarkable.defaultProps = { containerType: "div" };
//# sourceMappingURL=VReactMarkdown_Remarkable.js.map